import { useMemo } from 'react';
import {
  useNavigate,
  useSearchParams as useReactRouterSearchParams,
} from 'react-router-dom';

export const useRouter = () => {
  const navigate = useNavigate();

  return useMemo(
    () => ({
      push: (to: string) => navigate(to),
      replace: (to: string) => navigate(to, { replace: true }),
      back: () => navigate(-1),
    }),
    [navigate],
  );
};

export const useSearchParams = () => {
  const [searchParams] = useReactRouterSearchParams();
  return searchParams;
};
